import React from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';
import { useLang } from './LanguageContext';

const Header = () => {
    const { lang, toggleLang } = useLang();

    return (
        <Menu pointing secondary>
            <NavLink to='/' exact className="item" activeClassName="active item">
                Home
            </NavLink>
            <NavLink to='/about' className="item">
                About
            </NavLink>
            <NavLink to='/rn' className="item">
                Code
            </NavLink>
            <Menu.Menu position="right">
                <div className="item">
                    <button
                        className="lang-toggle"
                        onClick={toggleLang}
                        aria-label="Toggle language"
                        title={lang === 'en' ? 'Cambiar a Español' : 'Switch to English'}
                    >
                        <span className={lang === 'en' ? 'lang-option active' : 'lang-option'}>EN</span>
                        <span className="lang-separator">|</span>
                        <span className={lang === 'es' ? 'lang-option active' : 'lang-option'}>ES</span>
                    </button>
                </div>
            </Menu.Menu>
        </Menu>
    );
};

export default Header;